import { atom } from "jotai";

export const isArchiveOrderConfirmationModalOpenAtom = atom<boolean>(false);
